export default __webpack_public_path__ + "static/media/gothenburg_s2.67882fbe.png";